/* eslint-disable import/prefer-default-export */
import COLORS from '$variables/colors';

export const looks = {
  default: {
    color: COLORS.black,
    backgroundColor: COLORS.white,
    hoverBgColor: COLORS.beige,
  },
  purple: {
    color: COLORS.purple,
    backgroundColor: COLORS.purpleBg,
    hoverBgColor: COLORS.purpleHoverBg,
  },
};
